import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Capacitor } from "@capacitor/core";
import { sendPageView } from "./usageBeacon";

/**
 * On the web an app-host /live address only redirects to the live host, which
 * sends its own beacon (LiveApp.tsx); counting both would double every view.
 */
export function isRedirectOnly(pathname: string): boolean {
  return !Capacitor.isNativePlatform() && /^\/live(\/|$)/.test(pathname);
}

/**
 * One page-view beacon per screen opened (task #3068). Keyed on the pathname
 * only, so a query-string or hash change is not a new view. Production builds
 * only, so local development and tests never write to the live stats.
 */
export function usePageViews(): void {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!import.meta.env.PROD || isRedirectOnly(pathname)) return;
    sendPageView(pathname);
  }, [pathname]);
}
